'use strict';

import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Button, Form, Row, Col, Table, Card, InputGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Separator from '../helper/Separator';
import Alert from '../helper/Alert';
import { getCurrencyFormatter, formatDate } from '../helper/DateTimeFormater';

function AdditionalAbo() {
    const { request } = useRequest();

    const [curAbo, setCurAbo] = useState();
    const [newerAbo, setNewerAbo] = useState(false);
    const [abos, setAbos] = useState([]);
    const [step, setStep] = useState(0);
    const [couponCode, setCouponCode] = useState("");
    const [couponStatus, setCouponStatus] = useState("waiting");
    const [activeCoupon, setActiveCoupon] = useState(null);
    const [reduction, setReduction] = useState(0);

    const formRef = useRef(null);

    const cFormatter = getCurrencyFormatter();

    const [data, setData] = useState({});

    const handleAddAbo = async (values) => {
        const formData = { ...data, ...values };
        values.Price = values.Price * values.Period;
        const result = await request("/Business/AddAbo", { abo: values, couponCode: activeCoupon});
        const json = result.data;

        if (json.r == 1) {
            window.location.replace("/Business/Abo");
        }
        else {
            toast.error(json.message);
            setStep(0);
        }
    };

    const setAbo = async (index) => {
        setData(data => { return { ...data, abo: index } });
        let result = await request("/Business/GetNewAboDates", { period: abos[index].Period });
        let json = result.data;
        if (json.r != 1) {
            if (json.message) {
                toast.error(json.message);
            }
            else {
                toast.error("Es ist ein Fehler aufgetreten.");
            }
        }
        else {
            setCurAbo(json.abo);
            setNewerAbo(json.newerAbo);
        }
        setStep(1);
        document.getElementById("content").scrollIntoView();
    }

    const back = () => {
        setStep(step => Math.max(0, Math.min(step - 1, 4)));
        document.getElementById("content").scrollIntoView();
    }

    const couponChanged = async (e) => {
        try {
            const couponCode = e.currentTarget.value;

            if (!couponCode) {
                return;
            }

            setCouponStatus("loading");
            let result = await request("/Register/CheckCoupon", { code: couponCode });
            let json = result.data;
            if (json.r != 1) {
                setCouponStatus("error");
            }
            else {
                setCouponStatus("success");
                setActiveCoupon(couponCode);
                setReduction(json.reduction);
            }

        }
        catch (ex) {
            setCouponStatus("error");
            toast.error("Falscher Gutscheincode.");
        }
    };

    useEffect(() => {
        const getPresets = async () => {
            try {
                let result = await request("/Business/GetSubscriptionPresets");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten.");
                    }
                }
                else {
                    const head = json.abos.shift(); //Removes Schnupper-Abo
                    setCurAbo(json.curAbo);
                    if (json.curAbo.Name.includes("Premium")) { //Basis-Optionen entfernen falls bereits ein Premium-Abo gebucht ist.
                        setAbos(json.abos.slice(-2));
                    }
                    else {
                        setAbos(json.abos);
                    }           
                }
            }
            catch {
                toast.error("Fehler beim Laden");
            }
        };
        getPresets();
    }, []);

    // Paketauswahl
    if (step == 0) {
        if (abos === null)  return <Loader />;

        return (
            <>
                <Separator text="Paketauswahl" />
                <p>Bitte wählen Sie Ihr gewünschtes Paket aus.</p>
                <p>Entspricht keins der oberen Pakete Ihren Ansprüchen? Dann kontaktieren Sie uns gerne per E-Mail.</p>
                <Alert type="info">
                    <strong>Aktion:</strong> Beim Buchen eines beliebigen Abonnements erhalten Sie 3 Monate Laufzeit und 3 Termine gratis dazu.
                </Alert> 
                <Table>
                    <thead>
                        <tr>
                            <th className="level-0 border-top-0">Pakete</th>
                            {abos.map(i => <th key={i.AboID} className="level-1 text-center border-top-0">{i.Name}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="level-0">Laufzeit</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Period} Monate</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Mögliche Termine pro Monat</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Contingent / i.Period}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Anzahl Benutzer</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.User}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Anzahl Referenten</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Contactperson > 999 ? "Unbegrenzt" : i.Contactperson}</td>)}
                        </tr>
                        <tr>
                            <td className="level-0">Umkreis (PLZ Standort)</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{i.Radius > 300 ? "deutschlandweit" : i.Radius + " km"}</td>)}
                        </tr>
                        <tr>                          
                            <td className="level-0">Support (Hotline/Email)</td>
                            {abos.map((a, i) => <td key={a.AboID} className={"level-" + i + " text-center"}>Inklusive</td>)}                       
                        </tr>
                        <tr>
                            <td className="level-0">Preis pro Monat (exkl. MwSt)</td>
                            {abos.map(i => <td key={i.AboID} className="level-1 text-center">{cFormatter.format(i.Price)}</td>)}
                        </tr>
                        <tr className="book">
                            <td className="level-0"></td>
                            {abos.map((a, i) => <td key={a.AboID} className={"level-" + i + " text-center"}><button className="btn btn-secondary" onClick={() => setAbo(i)}>Auswählen</button></td>)}             

                        </tr>
                    </tbody>
                </Table>
                <Row>
                    <Col xs={12} lg={6}>
                        <Form.Group as={Row} className="mb-3" controlId="Coupon">
                            <Form.Label column sm={6}>Gutschein-Code</Form.Label>
                            <Col sm={6}>
                                <InputGroup>
                                    <Form.Control isInvalid={couponStatus == "error"} placeholder="" name="Coupon" value={couponCode} onChange={e => setCouponCode(e.target.value)} onBlur={couponChanged} aria-label="Gutschein-Code" />
                                    <InputGroup.Text>
                                        {couponStatus == "waiting" && <i className="fas fa-fw fa-percent"></i>}
                                        {couponStatus == "loading" && <i class="fas fa-fw fa-spinner fa-spin-pulse"></i>}
                                        {couponStatus == "error" && <i class="fas fa-fw fa-exclamation text-danger"></i>}
                                        {couponStatus == "success" && <i class="fas fa-fw fa-check text-success"></i>}
                                    </InputGroup.Text>
                                </InputGroup>
                            </Col>
                        </Form.Group>
                        {couponStatus == "error" && (
                            <div className="text-danger">Der eingegebene Gutscheincode ist ungültig.</div>
                        )}
                        {couponStatus == "success" && (
                            <div className="text-success">Gutscheincode erfolgreich aktiviert.</div>
                        )}
                    </Col>
                </Row>
                <div>
                    <Button type="button" variant="primary" onClick={() => location.pathname = "/Business/Abo"}><i className="fa-solid fa-chevron-left mr-2"></i>Zurück</Button>
                </div>
            </>
        );
    }

    // Übersicht + Bestätigung Buchung
    if (step == 1) {
        const selectedAbo = abos[data.abo];
        if (!selectedAbo) selectedAbo = {};

        return (
            <Formik
                innerRef={(f) => formRef.current = f}
                validateOnChange={true} 
                validateOnBlur={true}
                onSubmit={(values) => {
                    handleAddAbo(values);
                }}
                initialValues={selectedAbo}
            >
                {({
                    handleSubmit,
                }) => {

                    return (
                        <Form noValidate onSubmit={handleSubmit} className="mt-3">
                            <Separator text="Zusammenfassung" />
                            <Alert type="info">
                                <strong>Aktion:</strong> Beim Buchen eines beliebigen Abonnements erhalten Sie 3 Monate Laufzeit und 3 Termine gratis dazu.
                            </Alert> 
                            <Row className="mb-3">
                                <Col sm={12} lg={6}>
                                    <Card>
                                        <Card.Header>Ausgewähltes Paket</Card.Header>
                                        <Card.Body className="py-2">
                                            <Table size="sm" className="mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-top-0">Paketname</td>
                                                        <td className="text-right border-top-0">
                                                            {selectedAbo.Name}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Termine pro Monat</td>
                                                        <td className="text-right">
                                                            {selectedAbo.Contingent/selectedAbo.Period}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Paketlaufzeit</td>
                                                        <td className="text-right">
                                                            {selectedAbo.Period} Monate
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Preis pro Monat (exkl. MwSt)</td>
                                                        <td className="text-right">
                                                            {cFormatter.format(selectedAbo.Price)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Preis Gesamt (exkl. MwSt)</td>
                                                        <td className="text-right">
                                                            {cFormatter.format(selectedAbo.Price * selectedAbo.Period)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Start</td>
                                                        <td className="text-right">
                                                            {formatDate(curAbo.Start)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Ende</td>
                                                        <td className="text-right">
                                                            {formatDate(curAbo.End)}
                                                        </td>
                                                    </tr>
                                                    {activeCoupon && (
                                                        <>
                                                            <tr>
                                                                <td>Aktivierter Gutscheincode</td>
                                                                <td className="text-right">
                                                                    {activeCoupon}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Reduzierter Preis pro Monat (exkl. MwSt)</td>
                                                                <td className="text-right">
                                                                    {selectedAbo.Price - selectedAbo.Price * (reduction / 100)} €
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <Row className="ml-3">
                                {(newerAbo) ? <p className="text-danger">Sie haben bereits ein nachfolgendes Abonnement gebucht. <br></br>Um ein weiteres Abonnement im Anschluss an Ihr Bestehendes buchen zu können, müssen Sie das bestehende Folgeabonnement stornieren oder sich an den Betreiber von bovest wenden. </p> : ''}
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Button type="button" variant="primary" onClick={() => back()}><i className="fa-solid fa-chevron-left mr-2"></i>Zurück</Button>
                                </Col>
                                <Col xs={6} className="text-right">
                                    <Button type="submit" disabled={newerAbo} variant="secondary"><i className="fa-solid fa-right-to-bracket mr-2"></i>Buchung bestätigen</Button>
                                </Col>
                            </Row>
                        </Form>
                    )
                }}
            </Formik>
        );
    }
}

export default AdditionalAbo;